import { render, staticRenderFns } from "./VideoSettingFrameRateSelect.vue?vue&type=template&id=4ed973db"
import script from "./VideoSettingFrameRateSelect.vue?vue&type=script&lang=js"
export * from "./VideoSettingFrameRateSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports